import React, { useState } from 'react';
import { Typography,  } from '@mui/material';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import CustomMenuItem from '../../../components/Menu/CustomMenuItem';
import CustomMenu from '../../../components/Menu';
import AssignedToMeHeading from './AssignedToMeHeading';
import CardLists from './CardLists';
import { useSelector } from 'react-redux';
import { selectAssignedTaskFilter } from '../../../redux/plannerFilterSlice';

function AllMyTask() {
   const todoTaskFilter = useSelector(selectAssignedTaskFilter);
  const [filter, setFilter] = useState(
    todoTaskFilter ? todoTaskFilter : "Mine"
  );
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleOpen = (e) => {
    setAnchorEl(e.currentTarget);
  };
  return (
    <div className="assign-to-me">
      <AssignedToMeHeading
        filter={filter}
        anchorEl={anchorEl}
        setFilter={setFilter}
        handleClose={handleClose}
        handleOpen={handleOpen}
      />
      <div className="assign-to-me-body">
        <CardLists filter={filter} />
      </div>
    </div>
  );
}

export default AllMyTask